hideReviewStars();
quickShopReviews();

function hideReviewStars() {
  const targetNodes = document.querySelectorAll(".yotpo-widget-instance");

  const config = { childList: true };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        const target = mutationList[mutationList.length - 1].target;
        const emptyReviewStarArray = Array.from(
          target.querySelectorAll(".yotpo-sr-star-empty")
        );
        if (emptyReviewStarArray.length === 5) {
          target.style.display = "none";
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  targetNodes.forEach((targetNode) => {
    observer.observe(targetNode, config);
  });
}

function quickShopReviews() {
  const targetNodes = document.querySelectorAll(".modal--quick-shop");
  const config = {
    classList: true,
    attributes: true,
    childList: true,
    subtree: true,
  };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.attributeName === "class") {
        const target = mutation.target;
        const productID = target.getAttribute("data-product-id");

        if (productID) {
          // Get reviews
          const productTitle = target.querySelector(".product-single__title");
          const reviewSection = target.querySelector(".rating-stars");
          if (!reviewSection) {
            fetch(
              `https://api-cdn.yotpo.com/v1/widget/CfWNlPC1pjITWD0QVu2rTJcNGgQAfHBPbOyOvgQ1/products/${productID}/reviews.json`
            )
              .then((response) => response.json())
              .then((reviews) => {
                const productDecimalRating =
                  reviews.response.bottomline.average_score;
                const reviewCount = reviews.response.bottomline.total_review;
                if(reviewCount !== 0) {
                productTitle.insertAdjacentHTML(
                  "afterend",
                  `
                <div class="yotpo-sr-bottom-line-summary">
                  <div class="rating-wrapper">
                  ${productDecimalRating ? createStars(productDecimalRating) : ""}
                  <span aria-hidden="true" class="snippet-rating-decimal">${
                    productDecimalRating && productDecimalRating != 0
                      ? productDecimalRating.toFixed(1)
                      : ""
                  }</span>
                </div>
                <div class="yotpo-sr-vertical-border" style="display: flex; place-self: center; height: 11px; border-right: 1px solid black; margin-right: 12px; margin-left: 0px;">
              </div>
              <div class="yotpo-sr-bottom-line-text yotpo-sr-bottom-line-text--right-panel" style="white-space: nowrap; font-size: 16px; line-height: 18px; text-align: start; font-family: &quot;Futura T OT Book&quot;; font-style: normal; font-weight: 400; color: rgb(0, 0, 0);">
               ${reviewCount} Reviews 
            </div>
              </div
            `
                );
              }
            });
          }
        }
      }
    }
  };
  const observer = new MutationObserver(callback);

  targetNodes.forEach((targetNode) => {
    observer.observe(targetNode, config);
  });
}

function createStars(reviewCount) {
  // get the whole number of stars from the review count
  const wholeStars = Math.floor(reviewCount);
  // get the decimal value of the review count
  const decimal = reviewCount - wholeStars;
  // find the closest .25 value
  const closestQuarter = Math.round(decimal * 4) / 4;
  return `
      <div aria-hidden="true" class="rating-stars">
        ${Array(wholeStars)
          .fill(0)
          .map(() => '<div class="star-v4 star-v4-100-filled"></div>')
          .join("")}
          ${
            wholeStars === 0
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
          ${
            wholeStars === 1
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
          ${
            wholeStars === 2
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
          ${
            wholeStars === 3
              ? `<div class="star-v4 star-v4-${
                  closestQuarter * 100
                }-filled"></div>
                <div class="star-v4 star-v4-0-filled"></div>`
              : ""
          }
        ${
          wholeStars === 4
            ? `<div class="star-v4 star-v4-${
                closestQuarter * 100
              }-filled"></div>`
            : ""
        }
      </div>
    `;
}
